import { render, staticRenderFns } from "./ResRouter.vue?vue&type=template&id=0f06af19&scoped=true&"
import script from "./ResRouter.vue?vue&type=script&lang=js&"
export * from "./ResRouter.vue?vue&type=script&lang=js&"
import style0 from "./ResRouter.vue?vue&type=style&index=0&id=0f06af19&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f06af19",
  null
  
)

export default component.exports